import React, {useState} from 'react';
import {getWorkColor, workCodes} from "../table-cell/occupation-codes";
import css from "../occupation-buttons/occupation.module.css";

const OccupationButtons = ({toggleSelection, toggleWriteChanges}) => {
    /**
     * Выбираем занятость
     */
    const [chooseOccupation, setChooseOccupation] = useState(null);
    const handleOccupationClick = (letter) => {
        setChooseOccupation(letter);
    };

    /**
     * Снимаем выделение и скрываем кнопки
     */
    const handleClearSelection = () => {
        toggleSelection();
    };

    /**
     * Отправляем изменения на бэк
     */
    const handleWriteChanges = () => {
        toggleWriteChanges(chooseOccupation);
    };

    return (
        <div className={css.editorPanel}>
            <div className={css.buttonContainer}>
                {Object.values(workCodes).map(({code, letter, name}) => (
                    <button
                        key={code}
                        type="button"
                        aria-label={name}
                        className={[
                            css.occupationButton,
                            getWorkColor(code) === 'work_code__emp' ? getWorkColor('emp--button') : getWorkColor(code),
                            chooseOccupation === code ? css.selectedButton : ''
                        ].filter(Boolean).join(' ')}
                        onClick={() => handleOccupationClick(code)}
                    >
                        {letter !== '' ? letter : '—'}
                    </button>
                ))}
                {chooseOccupation && (<div className={css.additionalButtons}>
                    <button
                        type="button"
                        className={css.cancelButton}
                        aria-label="Отменить редактирование"
                        onClick={handleClearSelection}
                    >❌
                    </button>
                    <button
                        type="button"
                        className={css.saveButton}
                        aria-label="Сохранить изменения"
                        onClick={handleWriteChanges}
                    >✅
                    </button>
                </div>)}
            </div>
        </div>);
};

export default OccupationButtons;
